import { useMutation, useQuery, useQueryClient } from 'react-query'
import { ActivationObject } from '../../components/providers/ActivationObjectProvider/types'
import { ProblemDetails } from '../errors'
import { getActivationObject, getInterests, postActivationObject, putActivationObject, putInterests, putFinish } from './services'
import { ActivationBody, ApiInterests, ApiPutInterests } from './types'

export const QUERYKEY_ACTIVATIONOBJECT = 'activation-object'
export function useActivationObjectQuery(synonym?: string) {
    return useQuery<ActivationObject, ProblemDetails>(QUERYKEY_ACTIVATIONOBJECT, () => getActivationObject(synonym), {
        enabled: synonym !== undefined,
        retry: false,
    })
}

export function useActivationObjectUpdateMutation() {
    const queryClient = useQueryClient()
    return useMutation<ActivationObject, ProblemDetails, ActivationObject>(
        (object: ActivationObject) => putActivationObject(object),
        {
            onSuccess: (data) => {
                queryClient.setQueryData(QUERYKEY_ACTIVATIONOBJECT, { ...data, loadedAt: new Date() })
            },
        }
    )
}

export function useActivationObjectCreateMutation() {
    const queryClient = useQueryClient()
    return useMutation<ActivationObject, ProblemDetails, ActivationBody>(
        (activationBody: ActivationBody) => postActivationObject(activationBody),
        {
            onSuccess: () => queryClient.invalidateQueries(QUERYKEY_ACTIVATIONOBJECT),
        }
    )
}

export const QUERYKEY_INTERESTS = 'interests'
export function useInterestsQuery(synonym?: string) {
    return useQuery<ApiInterests, ProblemDetails>(QUERYKEY_INTERESTS, () => getInterests(synonym), {
        enabled: synonym !== undefined,
        retry: false,
    })
}

export function useFinishMutation() {
    const queryClient = useQueryClient()
    return useMutation<ActivationObject, ProblemDetails, string>((synonym: string) => putFinish(synonym), {
        onSuccess: () => queryClient.invalidateQueries(QUERYKEY_ACTIVATIONOBJECT),
    })
}

export function useInterestsUpdateMutation() {
    const queryClient = useQueryClient()
    return useMutation<ApiInterests, ProblemDetails, ApiPutInterests>((interests: ApiPutInterests) => putInterests(interests), {
        onSuccess: (data) => {
            queryClient.setQueryData(QUERYKEY_INTERESTS, data)
        },
    })
}
